const map = {
	"./avatar.svg": 6321,
	"./avatar100x100.png": 7076,
	"./avatar150x150.png": 8192,
	"./avatar400x400.png": 4484,
	"./avatar80x80.png": 2588,
	"./favicon.ico": 235
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9085;